import React from 'react'
import AutoFillStepper from '../autoFill/AutoFillStepper'

const FileUploadRepository = ({ percent, gifFile, from, to, fileName, filesUploaded, totalFiles, heading, onMinimize, onCancel, stepperStep }) => {

    return (
        <div
            id="fileUploadRepository"
            className="td500 zi4 pen df jcc aic fdc"
            style={{ padding: "1rem", width: '100%', maxWidth: '1000px' }}
        >
            {stepperStep && <AutoFillStepper currentStep={stepperStep} />}
            {gifFile}

            <div className='df jcsb' style={{ width: "97%" }}>
                <p className='fs12px c43'> {from}</p>
                <p className='fs12px c43'> {to}</p>
            </div>

            <div className="maw70 w700px df fdc jcc aic mt0rem">
                <h1 className='c15 fs24px w100 tac fw500'> {heading || 'Uploading Files'} </h1>
                <div className="w100 df jcc aic mt1rem">
                    <progress color="green" className="maw90 w90 mr1rem" style={{ border: 'none' }} id="upload-progress-bar" value={percent} max="100"></progress>
                </div>
                {
                    fileName ? <div className='df aic jcc'>
                        <span className='c15 fw500 fs13px my0-5rem'> {fileName} | {filesUploaded} / {totalFiles}</span>
                    </div> : null
                }

                <p className='c15 fs1rem w100 tac fw400 my2rem'>Almost there</p>

                {(onMinimize || onCancel) && (
                    <div className='df aic jcc' style={{ gap: '1rem', marginTop: '0.5rem' }}>
                        {onCancel && (
                            <button onClick={onCancel} style={{ background: 'none', border: '1.5px solid #9CA3AF', borderRadius: '6px', cursor: 'pointer', color: '#6B7280', fontSize: '13px', fontWeight: 500, padding: '0.3rem 1.2rem' }}>
                                Cancel
                            </button>
                        )}
                        {onMinimize && (
                            <button onClick={onMinimize} style={{ background: 'none', border: '1.5px solid #3B82F6', borderRadius: '6px', cursor: 'pointer', color: '#3B82F6', fontSize: '13px', fontWeight: 500, padding: '0.3rem 1.2rem' }}>
                                Minimize
                            </button>
                        )}
                    </div>
                )}
            </div>

        </div>
    )
}

export default FileUploadRepository